import type { ReactNode } from 'react'

export interface StatProps {
  label: ReactNode
  value: ReactNode
  hint?: ReactNode
  className?: string
}

/** A label over a figure. Figures are JetBrains Mono so columns align. */
export function Stat({ label, value, hint, className = '' }: StatProps) {
  return (
    <div className={`min-w-0 ${className}`}>
      <div className="soc-label">{label}</div>
      <div className="soc-num mt-1 truncate text-[17px] text-ink">{value}</div>
      {hint && <div className="mt-0.5 text-[13px] text-ink-mute">{hint}</div>}
    </div>
  )
}
